{
    "description": "TYPE: CUSTOM\nMaterial Theme Builder export 2024-09-17 11:28:50",
    "seed": "#244277",
    "coreColors": {
        "primary": "#244277",
        "secondary": "#2F8F65",
        "tertiary": "#B65C4D",
        "error": "#D06B2F"
    },
    "extendedColors": [],
    "schemes": {
        "light": {
            "primary": "#445E91",
            "surfaceTint": "#445E91",
            "onPrimary": "#FFFFFF",
            "primaryContainer": "#D8E2FF",
            "onPrimaryContainer": "#001A41",
            "secondary": "#2F8F65",
            "onSecondary": "#FFFFFF",
            "secondaryContainer": "#CFF0DF",
            "onSecondaryContainer": "#0D2C1F",
            "tertiary": "#B65C4D",
            "onTertiary": "#FFFFFF",
            "tertiaryContainer": "#FFDAD4",
            "onTertiaryContainer": "#43140C",
            "error": "#D06B2F",
            "onError": "#FFFFFF",
            "errorContainer": "#FFDCC6",
            "onErrorContainer": "#3C1500",
            "background": "#F4F6FA",
            "onBackground": "#131620",
            "surface": "#F4F6FA",
            "onSurface": "#131620",
            "surfaceVariant": "#E4E7EE",
            "onSurfaceVariant": "#444A53",
            "outline": "#828A96",
            "outlineVariant": "#D1D6DF",
            "shadow": "#000000",
            "scrim": "#000000",
            "inverseSurface": "#242832",
            "inverseOnSurface": "#F2F4F8",
            "inversePrimary": "#B7C9F5",
            "primaryFixed": "#D8E2FF",
            "onPrimaryFixed": "#001A41",
            "primaryFixedDim": "#ADC6FF",
            "onPrimaryFixedVariant": "#2B4678",
            "secondaryFixed": "#CFF0DF",
            "onSecondaryFixed": "#0D2C1F",
            "secondaryFixedDim": "#A9D8C4",
            "onSecondaryFixedVariant": "#1D5F44",
            "tertiaryFixed": "#FFDAD4",
            "onTertiaryFixed": "#43140C",
            "tertiaryFixedDim": "#F5B7AB",
            "onTertiaryFixedVariant": "#6E2F24",
            "surfaceDim": "#DEE2EB",
            "surfaceBright": "#F9FBFF",
            "surfaceContainerLowest": "#FFFFFF",
            "surfaceContainerLow": "#F7F8FC",
            "surfaceContainer": "#EEF1F7",
            "surfaceContainerHigh": "#E7EBF3",
            "surfaceContainerHighest": "#E0E4ED"
        },
        "light-medium-contrast": {
            "primary": "#274273",
            "surfaceTint": "#445E91",
            "onPrimary": "#FFFFFF",
            "primaryContainer": "#5A74A9",
            "onPrimaryContainer": "#FFFFFF",
            "secondary": "#2B7A58",
            "onSecondary": "#FFFFFF",
            "secondaryContainer": "#4DA17D",
            "onSecondaryContainer": "#FFFFFF",
            "tertiary": "#8A3E34",
            "onTertiary": "#FFFFFF",
            "tertiaryContainer": "#C7776A",
            "onTertiaryContainer": "#FFFFFF",
            "error": "#AF541C",
            "onError": "#FFFFFF",
            "errorContainer": "#D67A3E",
            "onErrorContainer": "#FFFFFF",
            "background": "#F4F6FA",
            "onBackground": "#131620",
            "surface": "#F4F6FA",
            "onSurface": "#131620",
            "surfaceVariant": "#E4E7EE",
            "onSurfaceVariant": "#3F444E",
            "outline": "#656D79",
            "outlineVariant": "#8B94A1",
            "shadow": "#000000",
            "scrim": "#000000",
            "inverseSurface": "#242832",
            "inverseOnSurface": "#F2F4F8",
            "inversePrimary": "#B7C9F5",
            "primaryFixed": "#5A74A9",
            "onPrimaryFixed": "#FFFFFF",
            "primaryFixedDim": "#415B8F",
            "onPrimaryFixedVariant": "#FFFFFF",
            "secondaryFixed": "#4DA17D",
            "onSecondaryFixed": "#FFFFFF",
            "secondaryFixedDim": "#398E6B",
            "onSecondaryFixedVariant": "#FFFFFF",
            "tertiaryFixed": "#C7776A",
            "onTertiaryFixed": "#FFFFFF",
            "tertiaryFixedDim": "#A95D51",
            "onTertiaryFixedVariant": "#FFFFFF",
            "surfaceDim": "#DEE2EB",
            "surfaceBright": "#F9FBFF",
            "surfaceContainerLowest": "#FFFFFF",
            "surfaceContainerLow": "#F7F8FC",
            "surfaceContainer": "#EEF1F7",
            "surfaceContainerHigh": "#E7EBF3",
            "surfaceContainerHighest": "#E0E4ED"
        },
        "light-high-contrast": {
            "primary": "#00204E",
            "surfaceTint": "#445E91",
            "onPrimary": "#FFFFFF",
            "primaryContainer": "#274273",
            "onPrimaryContainer": "#FFFFFF",
            "secondary": "#00341D",
            "onSecondary": "#FFFFFF",
            "secondaryContainer": "#1E5B41",
            "onSecondaryContainer": "#FFFFFF",
            "tertiary": "#4F130C",
            "onTertiary": "#FFFFFF",
            "tertiaryContainer": "#7A3025",
            "onTertiaryContainer": "#FFFFFF",
            "error": "#3C1500",
            "onError": "#FFFFFF",
            "errorContainer": "#7C2E00",
            "onErrorContainer": "#FFFFFF",
            "background": "#F4F6FA",
            "onBackground": "#131620",
            "surface": "#F4F6FA",
            "onSurface": "#000000",
            "surfaceVariant": "#E4E7EE",
            "onSurfaceVariant": "#1F242D",
            "outline": "#414651",
            "outlineVariant": "#414651",
            "shadow": "#000000",
            "scrim": "#000000",
            "inverseSurface": "#242832",
            "inverseOnSurface": "#FFFFFF",
            "inversePrimary": "#E6ECFF",
            "primaryFixed": "#274273",
            "onPrimaryFixed": "#FFFFFF",
            "primaryFixedDim": "#0B2B5C",
            "onPrimaryFixedVariant": "#FFFFFF",
            "secondaryFixed": "#1E5B41",
            "onSecondaryFixed": "#FFFFFF",
            "secondaryFixedDim": "#0C3F2A",
            "onSecondaryFixedVariant": "#FFFFFF",
            "tertiaryFixed": "#7A3025",
            "onTertiaryFixed": "#FFFFFF",
            "tertiaryFixedDim": "#5B1D15",
            "onTertiaryFixedVariant": "#FFFFFF",
            "surfaceDim": "#DEE2EB",
            "surfaceBright": "#F9FBFF",
            "surfaceContainerLowest": "#FFFFFF",
            "surfaceContainerLow": "#F7F8FC",
            "surfaceContainer": "#EEF1F7",
            "surfaceContainerHigh": "#E7EBF3",
            "surfaceContainerHighest": "#E0E4ED"
        },
        "dark": {
            "primary": "#ADC6FF",
            "surfaceTint": "#ADC6FF",
            "onPrimary": "#102F60",
            "primaryContainer": "#2B4678",
            "onPrimaryContainer": "#D8E2FF",
            "secondary": "#91D0B0",
            "onSecondary": "#0A2F1F",
            "secondaryContainer": "#1D5E44",
            "onSecondaryContainer": "#B4F0D6",
            "tertiary": "#FFB4A7",
            "onTertiary": "#5C1B12",
            "tertiaryContainer": "#763026",
            "onTertiaryContainer": "#FFDAD3",
            "error": "#FFB68A",
            "onError": "#4A1D00",
            "errorContainer": "#74340E",
            "onErrorContainer": "#FFDCC6",
            "background": "#0F1116",
            "onBackground": "#E4E7EE",
            "surface": "#11131A",
            "onSurface": "#E4E7EE",
            "surfaceVariant": "#404550",
            "onSurfaceVariant": "#C6CBD6",
            "outline": "#8D929D",
            "outlineVariant": "#424754",
            "shadow": "#000000",
            "scrim": "#000000",
            "inverseSurface": "#E4E7EE",
            "inverseOnSurface": "#11131A",
            "inversePrimary": "#3D568A",
            "primaryFixed": "#D8E2FF",
            "onPrimaryFixed": "#001A41",
            "primaryFixedDim": "#ADC6FF",
            "onPrimaryFixedVariant": "#2B4678",
            "secondaryFixed": "#B4F0D6",
            "onSecondaryFixed": "#002216",
            "secondaryFixedDim": "#91D0B0",
            "onSecondaryFixedVariant": "#1D5E44",
            "tertiaryFixed": "#FFDAD3",
            "onTertiaryFixed": "#3F0E07",
            "tertiaryFixedDim": "#FFB4A7",
            "onTertiaryFixedVariant": "#763026",
            "surfaceDim": "#11131A",
            "surfaceBright": "#353945",
            "surfaceContainerLowest": "#0A0C12",
            "surfaceContainerLow": "#161820",
            "surfaceContainer": "#1B1D25",
            "surfaceContainerHigh": "#252832",
            "surfaceContainerHighest": "#2F323D"
        },
        "dark-medium-contrast": {
            "primary": "#B4CBFF",
            "surfaceTint": "#ADC6FF",
            "onPrimary": "#001537",
            "primaryContainer": "#7790C7",
            "onPrimaryContainer": "#000000",
            "secondary": "#9DD9BD",
            "onSecondary": "#001E11",
            "secondaryContainer": "#649F83",
            "onSecondaryContainer": "#000000",
            "tertiary": "#FFC0B3",
            "onTertiary": "#310904",
            "tertiaryContainer": "#CD7F72",
            "onTertiaryContainer": "#000000",
            "error": "#FFC298",
            "onError": "#1E0C00",
            "errorContainer": "#B67346",
            "onErrorContainer": "#000000",
            "background": "#0F1116",
            "onBackground": "#E4E7EE",
            "surface": "#11131A",
            "onSurface": "#FBFAFF",
            "surfaceVariant": "#404550",
            "onSurfaceVariant": "#CDD2DD",
            "outline": "#A3A7B2",
            "outlineVariant": "#868B97",
            "shadow": "#000000",
            "scrim": "#000000",
            "inverseSurface": "#E2E2E9",
            "inverseOnSurface": "#282A2F",
            "inversePrimary": "#2C4779",
            "primaryFixed": "#D8E2FF",
            "onPrimaryFixed": "#00102D",
            "primaryFixedDim": "#ADC6FF",
            "onPrimaryFixedVariant": "#183566",
            "secondaryFixed": "#B4F0D6",
            "onSecondaryFixed": "#001A0F",
            "secondaryFixedDim": "#91D0B0",
            "onSecondaryFixedVariant": "#0E5037",
            "tertiaryFixed": "#FFDAD3",
            "onTertiaryFixed": "#280603",
            "tertiaryFixedDim": "#FFB4A7",
            "onTertiaryFixedVariant": "#62271E",
            "surfaceDim": "#11131A",
            "surfaceBright": "#353945",
            "surfaceContainerLowest": "#0A0C12",
            "surfaceContainerLow": "#161820",
            "surfaceContainer": "#1B1D25",
            "surfaceContainerHigh": "#252832",
            "surfaceContainerHighest": "#2F323D"
        },
        "dark-high-contrast": {
            "primary": "#FBFAFF",
            "surfaceTint": "#ADC6FF",
            "onPrimary": "#000000",
            "primaryContainer": "#B4CBFF",
            "onPrimaryContainer": "#000000",
            "secondary": "#E7FFEF",
            "onSecondary": "#000000",
            "secondaryContainer": "#9DD9BD",
            "onSecondaryContainer": "#000000",
            "tertiary": "#FFF8F5",
            "onTertiary": "#000000",
            "tertiaryContainer": "#FFC0B3",
            "onTertiaryContainer": "#000000",
            "error": "#FFF4EA",
            "onError": "#000000",
            "errorContainer": "#FFC298",
            "onErrorContainer": "#000000",
            "background": "#111318",
            "onBackground": "#E2E2E9",
            "surface": "#111318",
            "onSurface": "#FFFFFF",
            "surfaceVariant": "#404550",
            "onSurfaceVariant": "#FBFAFF",
            "outline": "#CED2DD",
            "outlineVariant": "#CED2DD",
            "shadow": "#000000",
            "scrim": "#000000",
            "inverseSurface": "#E2E2E9",
            "inverseOnSurface": "#000000",
            "inversePrimary": "#062859",
            "primaryFixed": "#DEE6FF",
            "onPrimaryFixed": "#000000",
            "primaryFixedDim": "#B4CBFF",
            "onPrimaryFixedVariant": "#001537",
            "secondaryFixed": "#C2F4B6",
            "onSecondaryFixed": "#000000",
            "secondaryFixedDim": "#A7D89C",
            "onSecondaryFixedVariant": "#001C02",
            "tertiaryFixed": "#FFE0DE",
            "onTertiaryFixed": "#000000",
            "tertiaryFixedDim": "#FFB9B6",
            "onTertiaryFixedVariant": "#330407",
            "surfaceDim": "#11131A",
            "surfaceBright": "#353945",
            "surfaceContainerLowest": "#0A0C12",
            "surfaceContainerLow": "#161820",
            "surfaceContainer": "#1B1D25",
            "surfaceContainerHigh": "#252832",
            "surfaceContainerHighest": "#2F323D"
        }
    },
    "palettes": {
        "primary": {
            "0": "#000000",
            "5": "#00102D",
            "10": "#001A41",
            "15": "#002455",
            "20": "#0B2F63",
            "25": "#1B3A6F",
            "30": "#28467B",
            "35": "#355288",
            "40": "#425E94",
            "50": "#5B77AF",
            "60": "#7590CB",
            "70": "#8FABE7",
            "80": "#ADC6FF",
            "90": "#D8E2FF",
            "95": "#EDF0FF",
            "98": "#F9F9FF",
            "99": "#FEFBFF",
            "100": "#FFFFFF"
        },
        "secondary": {
            "0": "#000000",
            "5": "#01130B",
            "10": "#052018",
            "15": "#0A2C21",
            "20": "#0F382A",
            "25": "#154533",
            "30": "#1C523D",
            "35": "#235F47",
            "40": "#2B6D51",
            "50": "#3C8A67",
            "60": "#53A57E",
            "70": "#6ABF97",
            "80": "#86DBB2",
            "90": "#C4F4DC",
            "95": "#E4FFF1",
            "98": "#F2FFF8",
            "99": "#F7FFFA",
            "100": "#FFFFFF"
        },
        "tertiary": {
            "0": "#000000",
            "5": "#210403",
            "10": "#340A08",
            "15": "#41100D",
            "20": "#4E1713",
            "25": "#5C1F19",
            "30": "#6A271F",
            "35": "#783026",
            "40": "#87392E",
            "50": "#A85343",
            "60": "#C96D5B",
            "70": "#E38875",
            "80": "#FFC7BD",
            "90": "#FFDAD4",
            "95": "#FFEDEA",
            "98": "#FFF7F5",
            "99": "#FFFBFA",
            "100": "#FFFFFF"
        },
        "neutral": {
            "0": "#000000",
            "5": "#0E1015",
            "10": "#181A1F",
            "15": "#22252B",
            "20": "#2D3036",
            "25": "#383B42",
            "30": "#44474F",
            "35": "#50535B",
            "40": "#5D6069",
            "50": "#767984",
            "60": "#9094A0",
            "70": "#AAAFBB",
            "80": "#C6CAD5",
            "90": "#E2E6F0",
            "95": "#F1F4FA",
            "98": "#F7F9FE",
            "99": "#FBFCFF",
            "100": "#FFFFFF"
        },
        "neutral-variant": {
            "0": "#000000",
            "5": "#0D1014",
            "10": "#181B20",
            "15": "#22262C",
            "20": "#2D3137",
            "25": "#383C43",
            "30": "#44484F",
            "35": "#50555C",
            "40": "#5C6169",
            "50": "#747A83",
            "60": "#8E949E",
            "70": "#A9AFB9",
            "80": "#C5CBD6",
            "90": "#E1E6F0",
            "95": "#EFF3FA",
            "98": "#F6F9FE",
            "99": "#FBFCFF",
            "100": "#FFFFFF"
        }
    }
}